// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"118cebf8","217":"b37786df","331":"b6744667","399":"c0b595f6","474":"f2305856","743":"34b64bae","844":"ed6157eb","906":"57ab8c05","932":"39114fcd","941":"66505f42"}[chunkId] + ".chunk.js";
};